import { interpreter } from "../../HKT/index.mjs";
import { DecoderURI } from "../base/index.mjs";
export const interpreters = {};
export function decoderExtension(K) {
  return i => {
    interpreters[K] = i();
  };
}
export const decoderExtensionsInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  ...interpreters
}));
//# sourceMappingURL=extensions.mjs.map